var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Checkbox, Flex, Typography } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import { InternalModal } from '../../../components/InternalModal';
/**
 * Confirms a standalone organizer-space move from Event Details. Owns the
 * notify-attendees choice, and for recurring events carries the note that
 * the move is instance-only. There is no save here — only the move.
 */
export var ConfirmRoomChangeModal = function (_a) {
    var fromSpaceName = _a.fromSpaceName, toSpaceName = _a.toSpaceName, isRecurring = _a.isRecurring, confirming = _a.confirming, _b = _a.hideNotify, hideNotify = _b === void 0 ? false : _b, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    var t = useTranslation('modal').t;
    var _c = __read(useState(true), 2), notifyAttendees = _c[0], setNotifyAttendees = _c[1];
    var byline = (_jsxs(Flex, { vertical: true, gap: 12, children: [_jsx(Typography.Text, { type: "secondary", children: t('confirm_room_change_modal.byline', {
                    from: fromSpaceName,
                    to: toSpaceName,
                }) }), isRecurring && (_jsx(Typography.Text, { type: "secondary", children: t('confirm_room_change_modal.recurring_note') })), !hideNotify && (_jsx(Checkbox, { checked: notifyAttendees, onChange: function (e) { return setNotifyAttendees(e.target.checked); }, children: t('confirm_room_change_modal.notify_attendees') }))] }));
    return (_jsx(InternalModal, { onCancel: onCancel, onConfirm: function () { return onConfirm(notifyAttendees); }, title: t('confirm_room_change_modal.title'), confirming: confirming, byline: byline, confirmText: t('confirm_room_change_modal.confirm'), cancelText: t('confirm_room_change_modal.cancel') }));
};
